export const    DIAGNOSTIC_REPORT = 'DIAGNOSTIC_REPORT';
export const    DIAGNOSTIC_REPORT_SUCCESS = 'DIAGNOSTIC_REPORT_SUCCESS';
export const    DIAGNOSTIC_REPORT_ERROR = 'DIAGNOSTIC_REPORT_ERROR';

export const    DIAGNOSTIC_REPORT_FILTERS = 'DIAGNOSTIC_REPORT_FILTERS';
export const    DIAGNOSTIC_REPORT_FILTERS_SUCCESS = 'DIAGNOSTIC_REPORT_FILTERS_SUCCESS';
export const    DIAGNOSTIC_REPORT_FILTERS_ERROR = 'DIAGNOSTIC_REPORT_FILTERS_ERROR';